function checkPopupClosed() {
    const closedTime = localStorage.getItem('popupClosed');
    if (!closedTime) return false;
    const now = new Date().getTime();
    const minutes2 = 2 * 60 * 1000; // 2 minutes in milliseconds
    return (now - parseInt(closedTime)) < minutes2;
}

// Check URL for any of the specific keys
function checkUrlKey() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('sscid') || urlParams.has('affid') || urlParams.has('irclickid');
}

// Show popup
function showPopup() {
    if (!checkUrlKey()) return;
    if (checkPopupClosed()) return;

    document.getElementById('popupOverlay').style.display = 'block';
    document.getElementById('popup').style.display = 'block';
}

// Hide popup
function hidePopup() {
    document.getElementById('popupOverlay').style.display = 'none';
    document.getElementById('popup').style.display = 'none';

    // Store close time in localStorage
    const now = new Date().getTime();
    localStorage.setItem('popupClosed', now.toString());
}

// Inactivity timer
let inactivityTimer;
function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    if (!checkUrlKey() || checkPopupClosed()) return;

    inactivityTimer = setTimeout(() => {
        showPopup();
    // }, 15000);
      }, 15000);
}

// Initialize popup functionality
function initPopup() {
    // Desktop exit detection
    document.addEventListener('mouseleave', () => {
        if (!checkUrlKey() || checkPopupClosed()) return;
        showPopup();
    });

    // Common event listeners
    document.addEventListener('mousemove', resetInactivityTimer);
    document.addEventListener('keydown', resetInactivityTimer);
    document.getElementById('closeBtn').addEventListener('click', hidePopup);

    // Start inactivity timer only if key is present and popup not recently closed
    if (checkUrlKey() && !checkPopupClosed()) {
        resetInactivityTimer();
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initPopup);